import { AssessmentAnswerInterface } from 'app/assessment/models';
import { EmployeeEquipmentWorkflowInterface, EmployeeEquipmentWorkflowStatusTypeInterface, EquipmentCategoryInterface, EquipmentInterface } from 'app/equipment/models';

export interface EquipmentStateInterface {
  equipmentLibrary?: EquipmentCategoryInterface[];
  recommendedEquipmentLibrary?: EquipmentCategoryInterface[];
  statusTypes?: EmployeeEquipmentWorkflowStatusTypeInterface[];
  workAreas?: AssessmentAnswerInterface[];
  currentUserEquipmentWorkflows?: EmployeeEquipmentWorkflowInterface[];
  selectedWorkFlow?: EmployeeEquipmentWorkflowInterface;
  selectedEquipment?: EquipmentInterface;
  libraryLoading?: boolean;
}

export class EquipmentState implements EquipmentStateInterface {
  public equipmentLibrary?: EquipmentCategoryInterface[];
  public recommendedEquipmentLibrary?: EquipmentCategoryInterface[];
  public statusTypes?: EmployeeEquipmentWorkflowStatusTypeInterface[];
  public workAreas?: AssessmentAnswerInterface[];
  public currentUserEquipmentWorkflows?: EmployeeEquipmentWorkflowInterface[];
  public selectedWorkFlow?: EmployeeEquipmentWorkflowInterface;
  public selectedEquipment?: EquipmentInterface;
  public libraryLoading?: boolean;

  constructor({
    equipmentLibrary = undefined,
    recommendedEquipmentLibrary = undefined,
    statusTypes = undefined,
    workAreas = undefined,
    currentUserEquipmentWorkflows = undefined,
    selectedWorkFlow = undefined,
    selectedEquipment = undefined,
    libraryLoading = false,
    }: EquipmentStateInterface) {
    this.equipmentLibrary = equipmentLibrary;
    this.recommendedEquipmentLibrary = recommendedEquipmentLibrary;
    this.statusTypes = statusTypes;
    this.workAreas = workAreas;
    this.currentUserEquipmentWorkflows = currentUserEquipmentWorkflows;
    this.selectedWorkFlow = selectedWorkFlow;
    this.selectedEquipment = selectedEquipment;
    this.libraryLoading = libraryLoading;
  }
}
